import { z } from "zod";
import { poseScriptSchema, savedChatScriptSchema } from "../Loom";

export const BRUSHING_QUADRANT_DURATION_MS = 30_000;

const savedChatScriptSectionSchema = z.object({
  text: z.string(),
  poseScript: poseScriptSchema.optional(),
  durationMs: z.number().int().min(0).max(600_000).optional(),
});

export const brushingScriptSchema = savedChatScriptSchema.extend({
  sections: z.array(savedChatScriptSectionSchema).min(6).max(12),
});

export const flossingScriptSchema = savedChatScriptSchema.extend({
  sections: z.array(savedChatScriptSectionSchema).min(8).max(14),
});

export const preVisitScriptSchema = savedChatScriptSchema.extend({
  sections: z.array(savedChatScriptSectionSchema).min(6).max(12),
});

export type BrushingScript = z.infer<typeof brushingScriptSchema>;
export type FlossingScript = z.infer<typeof flossingScriptSchema>;
export type PreVisitScript = z.infer<typeof preVisitScriptSchema>;
